import { EventEmitter } from "@angular/core";
import { CertificateModel } from "../../shared/models/certificate.model";
import { ColumnModel } from "../../shared/models/column.model";
export class CertificateBuildData{
    module = {
        name: "Certificate",
        new_name: "certificate",
        filtered_name:"Certificate",
        has_dot_menu: true,
        icon:'fa-certificate',
        permission:'certificate'
    }
    
    onReload: EventEmitter < boolean > = new EventEmitter<boolean>();//Forces Reload of codeblack table on emit.
    rowFunction = (row:CertificateModel) => {//Generates Row for codeblack-table
        return CertificateModel.getListRow(row);
    }
    
    columns:ColumnModel[] = [
        {
            title: "Id",
            prop: "id",
            flex_grow: 1,
            row_accessor: "id",
            class:""//force-flex force-flex-end
        },
        {
            title: "User",
            prop: "first_name",
            flex_grow: 2,
            row_accessor: "name",
            class:""//force-flex force-flex-end
        },
        {
            title: "Email",
            prop: "email",
            flex_grow: 3,
            row_accessor: "email",
            class:""//force-flex force-flex-end
        },{
            title: "Route",
            prop: "camino",
            flex_grow: 2,
            row_accessor: "route",
            class:""//force-flex force-flex-end
        }
    ];

    constructor(){
        for(let col of this.columns){
            col = new ColumnModel(col);
        }
    }

}